import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export interface ReviewListItem {
  label: string;
  value: string | null | undefined;
}

interface ReviewListProps {
  title: string;
  updateLink: string;
  items: ReviewListItem[];
  titleTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export default function ReviewList({
  title,
  updateLink,
  items,
  titleTag = 'h3',
}: ReviewListProps): JSX.Element {
  const { t } = useTranslation();
  const TitleTag = titleTag.toLowerCase() as keyof JSX.IntrinsicElements;

  return (
    <div>
      <div>
        <div className="flex items-center justify-between">
          <TitleTag>{title}</TitleTag>
          <Link to={updateLink}>
            {t('buttons.update', 'Update', { ns: 'translation' })}
          </Link>
        </div>
      </div>
      <div className="mt-5 border-t border-gray-200">
        <dl className="sm:divide-y sm:divide-gray-200">
          {items.map((item) => (
            <div
              key={item.label}
              className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5"
            >
              <dt className="text-sm font-medium text-gray-500">
                {item.label}
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                {item.value ?? ''}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
